<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26.617"
    height="18.412"
    viewBox="0 0 26.617 18.412"
  >
    <g transform="translate(-697 -215.99)">
      <path
        d="M389.173,588.265l-1-.061a8.251,8.251,0,0,0-7.008-8.692l.152-.989A9.248,9.248,0,0,1,389.173,588.265Z"
        transform="translate(331.453 -362.533)"
        fill="#777"
      />
      <path
        d="M389.179,588.8l-4.745-1.5.3-.953,4.161,1.316,2.555-2.589.712.7Z"
        transform="translate(331.453 -362.533)"
        fill="#777"
      />
      <g transform="translate(287.097 -317.455)">
        <path
          d="M429.44,551.857a.5.5,0,0,1-.159-.026l-11.423-3.849H410.4a.5.5,0,0,1-.5-.5v-8.47a.5.5,0,0,1,.932-.251,9.418,9.418,0,0,0,1.835,2.262c1.207,1.263,2.7,1.233,5.034-.065a.688.688,0,0,0,.417-.525c.091-.7-.8-1.736-1.122-2.046a.5.5,0,0,1,.619-.78c.384.246,9.419,6.057,11.365,8.073,2.114,2.192.98,5.688.932,5.835A.5.5,0,0,1,429.44,551.857ZM410.9,546.982h7.037a.516.516,0,0,1,.16.026l10.991,3.7c.2-.935.454-3.006-.827-4.336-1.33-1.377-6.4-4.784-9.231-6.652a2.078,2.078,0,0,1,.08.84,1.684,1.684,0,0,1-.922,1.268c-1.718.958-4.229,1.988-6.218-.091a9.9,9.9,0,0,1-1.069-1.127Z"
          fill="#777"
        />
      </g>
    </g>
  </svg>
</template>
